import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {BoardDefaultStatusType, ItemDataFilterRequest} from 'models/board';
import {AppRootState} from 'store/appStore';

interface MyWorkState {
    filters: ItemDataFilterRequest;
}
const initialState: MyWorkState = {
    filters: {
        boardSlugs: [],
        itemStatusIds: [],
        sprintIds: [],
        itemStatusTypes: [BoardDefaultStatusType.Open, BoardDefaultStatusType.New],
    },
};
const myWorkSliceSlice = createSlice({
    name: 'myWork',
    initialState,
    reducers: {
        setMyWorkFilters: (state, action: PayloadAction<ItemDataFilterRequest>) => {
            state.filters = action.payload;
        },
    },
});

export const {setMyWorkFilters} = myWorkSliceSlice.actions;

export const myWorkSliceReducer = myWorkSliceSlice.reducer;
export const myWorkSelector = (rootState: AppRootState): MyWorkState => rootState.myWork;
